<template>
  <div>
    <div style="padding:0px 0px 10px 5px;font-size:18px;">Past Due Open Opportunitites</div>

      <v-data-table dense style="height: 399px;overflow-y:auto" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :headers="[{text: 'Owner', value: 'owner'},{text: 'Opportunity', value: 'opportunity'},{text: 'Stage', value: 'stage'},{text: 'Close Date', value: 'close_date'}]" :items="data" :items-per-page="-1" hide-default-footer fixed-header>
        <template v-slot:item="row">
            <tr>
              <td style="font-size:10px !important">{{row.item.owner}}</td>
              <td style="font-size:10px !important;max-width:200px;padding-top:2px"><span style="color:#223773;cursor: pointer;" @click="$router.push({name: 'Opportunity', params: {opportunityId: row.item.id}})">{{row.item.opportunity}}</span></br><span style="font-size:10px;font-style: italic">{{row.item.account}}</span></td>
              <td style="font-size:10px !important">{{row.item.stage}}</td>
              <td style="font-size:10px !important"><span style="color:red;font-style:bold">{{ formatDate(row.item.close_date) }}</span></td>
            </tr>
        </template>
      </v-data-table>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Moment from 'moment'

export default {
  props: {
    data: Array,
  },
  components: {},
  created() {},
  data() {
    return {
      sortBy: 'close_date',
      sortDesc: false,
    };
  },
  computed: {
    ...mapGetters({
      db: 'db',
      current_user: 'current_user'
    })
  },
  watch:{

  },
  methods: {
    formatDate(date){
      return Moment(date).format('MM/DD/YY')
    }
  }
};
</script>
